import React, { useEffect } from 'react';

const NotesPanel = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: NotesPanel is not implemented yet.');
  }, []);
  return (
    <>
  { /*NotesPanel */} 
 </>
  );
};

export default NotesPanel;
